module.exports = __webpack_public_path__ + "32c8c432f8689e8cb4a9c13690f9fd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_3-420.jpg
// module id = 301
// module chunks = 0